import React from 'react'

export default function ListaParceiros(props) {

  return (<>
    {props.children}
    {props.parceiros && props.parceiros.length > 0
      ?
      props.parceiros.map(parceiro =>
        <section className="">
          <div className="conteiner-fluid" style={{ marginLeft: '-10px', marginRight: '-10px' }}>
            <div className="clearfix">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="">
                  <div className="">
                    <div className="col-md-12">
                      <h6 className="text-black" key={Math.random()} id={parceiro.id}> <i className='zmdi zmdi-accounts'></i>  {parceiro.parceiro} <strong></strong></h6>
                      <hr />
                    </div>
                    <div className="col-md-12 text-muted text-uppercase">
                      <strong className='text-black' style={{ color: 'black' }}>{parceiro.parceiro_nome}</strong>
                      <span className='m-l-100 text-uppercase small right'> {parceiro.parceiro_descricao} </span> <br />
                      <address className='text-uppercase'>
                        ENDEREÇO: {parceiro.endereco} - CEP {parceiro.cep} <br />
                        {parceiro.cidade} - {parceiro.uf} <br />
                        TELEFONE: {parceiro.telefone} <br />
                        WEBSITE: <span className='text-lowercase' > <a href={parceiro.website} target='_blank' className='text-black-50'>{parceiro.website} </a> </span>
                      </address>
                    </div>
                    {parceiro.contatos.length > 0 &&
                      < div className="col-md-12 text-muted">
                        <br />
                        <p>
                          <strong><i className="zmdi zmdi-account"></i> CONTATOS </strong>
                        </p>
                        <div className="table-responsive">
                          <table id="mainTable" className="table table-striped table-condensed table-sm small">
                            <thead className='text-muted'>
                              <tr>
                                <th>SETOR</th>
                                <th>CONTATO</th>
                                <th>CARGO</th>
                                <th>TELEFONE</th>
                                <th>EMAIL</th>
                              </tr>
                            </thead>
                            <tbody className='text-muted'>
                              {parceiro.contatos.map(contato =>
                                <tr key={Math.random()}>
                                  <td className='text-uppercase'> {contato.setor} </td>
                                  <td className='text-uppercase'> {contato.contato}</td>
                                  <td className='text-uppercase'>{contato.cargo}</td>
                                  <td className='text-uppercase'>
                                    <a className='text-decoration-none text-muted' href={`tel:+55${contato.telefone}`}> {contato.telefone} </a>
                                  </td>
                                  <td className='text-lowercase'>
                                    <a href={`mailto:${contato.email}`} className='text-decoration-none text-muted'> {contato.email} </a>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    }

                    {parceiro.indicadores.length > 0 &&
                      <div className="col-md-12 text-muted">
                        <br />
                        <hr />
                        <p>
                          <strong> <i className="zmdi zmdi-chart"></i> ENTIDADE ENVOLVIDA NOS SEGUINTES ÍNDICES: </strong>
                          <span className='badge badge-pill right  '>{parceiro.indicadores.length} {parceiro.indicadores.length > 1 ? 'ÍNDICES' : 'ÍNDICE'}  </span>
                        </p>
                        <table className='table table-striped table-condensed table-sm small'>
                          <thead className='text-muted'>
                            <th>INDICADOR  </th>
                            <th>DESCRIÇÃO  </th>
                            <th>CATEGORIA  </th>
                            <th>UNIDADE  </th>
                            <th>PERIODICIDADE </th>
                          </thead>
                          <tbody>
                            {parceiro.indicadores.map(indicador =>
                              <tr className='text-muted'>
                                <td>{indicador.nome}</td>
                                <td> {indicador.descricao}</td>
                                <td>{indicador.categoria}</td>
                                <td>{indicador.unidade}</td>
                                <td>{indicador.periodicidade}</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <br />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div >
          </div >
        </section >
      )
      : null

    }
  </>
  );
}

